import { Meta } from "@angular/platform-browser";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router } from "@angular/router";
import { PhotoService } from "../services/photo.service";
import { Photo } from "../../../shared/models/cameralla-photo.model";
import { CamerallaAuthService } from "../../../shared/services/authentication-services/cameralla-auth.service";
import { ToastrService } from "ngx-toastr";
import { Location } from "@angular/common";
import { RatingService } from "../services/rating.service";
import { PhotoComment } from "../../../shared/models/cameralla-comment.model";
import { GlobalVariables } from "../../../shared/models/cameralla-global.model";
import { LikeService } from "../services/like.service";
import * as $ from "jquery";
import { CamerallaUser } from "../../../shared/models/cameralla-user.model";
import { UserService } from "../../user/services/user.service";
import { AppComponent } from "../../../app.component";
import { MapPopupComponent } from "../../upload/components/map-popup/map-popup.component";
import * as Cocoen from "cocoen";
import AppShareHelper from "../../../shared/utils/helper";
import { environment } from "../../../../environments/environment";
import { AppService } from "../../../core/services/app.service";
import { HttpClient } from "@angular/common/http";
import { GeoLocationService } from "../../../shared/services/geo-location.service";
import { LocationService } from "../../../shared/services/location.service";
import { UserComments } from "../services/user-comments.service";
import { UserStatusConstant } from "../../../shared/constants/user-status-constant";
import * as _ from "lodash";
import { MoveLocationForm } from "../move-location-form/move-location-form";
import { GroupService } from "../../user/services/group.service";
import { GroupLevel } from "../../../shared/constants/group-constant";
import { PermissionAdminService } from "../../../shared/services/guard-services/permission-admin.service";
import { TranslateService } from "../../../shared/services/translate.service";
import { BioService } from "../../../shared/services/bio.service";
import { BioModel } from "../../../shared/models/cameralla-bio.model";

@Component({
  selector: "app-photo-details",
  templateUrl: "./photo-details.component.html",
  providers: [GeoLocationService],
})
export class PhotoDetailsComponent implements OnInit, OnDestroy {
  static readonly maxWidthMobile = 991;
  currentPartner = GlobalVariables.CURRENT_PARTNER;
  localUserId;
  photoDetails: Photo;
  photoId: number;
  promiseLike;
  photosByUser: Photo[] = [];
  similarPhotos: Photo[] = [];
  tags = [];
  modalRef;
  isGroupAdmin = false;
  photoComments: PhotoComment[];
  myBioInfo: BioModel | any = {
    photoIds: [],
  };
  photoBioIds = [];
  bioActive = false;
  editFeedback: boolean;
  public reloadComment = false;
  criterion = [
    "general",
    "vision",
    "composition",
    "cameraSettings",
    "editing",
    "presentation",
  ];
  tabComment = this.criterion[0] + "_text";
  tagCollection = GlobalVariables.tag_collection;
  ownerPhoto: any = {};
  defaultErrorPhoto = "./assets/images/default-error-photo.png";
  showMap: boolean = false;
  editedPhotoSrc: string;
  showComparisonSlider: boolean = false;
  photoLoaded: boolean = false;
  locationDetail: any = {};
  primaryPhoto = null;
  isAdmin = false;
  isModerator = false;
  canDoGlobalAction: boolean = false;
  canDeletePhoto: boolean = false;
  checkGoldenLocation: boolean = false;
  isGoldenPhoto = 0;
  fromUserPage = false;
  deletedUser = false;
  partners = [];
  backToFeed =
    "/" +
    (this.currentPartner.value === "vip"
      ? "member-feeds"
      : this.currentPartner.value) +
    "/" +
    (this.currentPartner.id == 1 ? "" : this.currentPartner.id);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private photoService: PhotoService,
    private ratingService: RatingService,
    private modalService: NgbModal,
    private authService: CamerallaAuthService,
    private groupService: GroupService,
    private toastr: ToastrService,
    private location: Location,
    private likeService: LikeService,
    private userService: UserService,
    private geoLocationService: GeoLocationService,
    private userCommentsService: UserComments,
    private locationService: LocationService,
    private translateService: TranslateService,
    private meta: Meta,
    private bioService: BioService,
    protected http: HttpClient
  ) {
    this.localUserId = +this.authService.getLocalUserInfo()["id"];
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params && params.commentType) {
        this.tabComment = params.commentType;
      }

      if (params && params.userId) {
        this.backToFeed =
          "/user/" +
          (this.localUserId == params.userId ? "myPage" : params.userId);
        this.fromUserPage = true;
      }
    });

    this.route.params.subscribe((params) => {
      this.getPartner();
      this.showComparisonSlider = false;
      this.editedPhotoSrc = null;
      this.showMap = false;
      this.canDoGlobalAction = false;
      this.canDeletePhoto = false;
      this.deletedUser = false;
      this.isGroupAdmin = false;
      this.isGoldenPhoto = 0;
      this.locationDetail = {};
      this.primaryPhoto = null;
      this.getPhotoDetails(params["id"]);
      window.scroll(0, 0);
    });
  }

  ngAfterViewInit() {}

  getPhotoDetails(photoId, afterUpdate?) {
    this.photoService.modifiedPhoto = null;
    this.photoService.getPhotoDetails(photoId, true, this.localUserId).then(
      (res) => {
        if (res["Data"]) {
          this.photoDetails = res["Data"];
          if (this.photoDetails.customerId === this.localUserId) {
            this.bioService
              .getMyBio()
              .toPromise()
              .then((bioData: any) => {
                if (bioData.Data) {
                  this.myBioInfo = bioData.Data;
                }
                this.bioActive = AppShareHelper.checkVipMember(
                  this.photoDetails.customer.accessLevel
                );
              });
          }
          if (afterUpdate) {
            this.photoService.modifiedPhoto = this.photoDetails;
            this.toastr.success("Give rating successfully", "SUCCESS");
          }

          let groupList = [];
          this.groupService
            .getMyGroups(this.localUserId, "joined")
            .subscribe((groups: any) => {
              if (groups && groups.Data && groups.Data.length) {
                groupList = groups.Data;
              }

              if (this.photoDetails.groupId) {
                const groupUser = _.find(groupList, (o) => {
                  return o.group.id == this.photoDetails.groupId;
                });
                if (!groupUser) {
                  this.toastr.error("You cannot view this photo", "ERROR");
                  this.router.navigate(["/user/my-groups"]);
                } else {
                  this.isGroupAdmin =
                    groupUser.level == GroupLevel.admin ||
                    groupUser.level == GroupLevel.moderator;
                  this.canDeletePhoto =
                    this.isGroupAdmin &&
                    groupUser.group.metaData &&
                    groupUser.group.metaData.delelePhotoFeature;
                }
              }
            });

          if (
            this.photoDetails.locationId &&
            !this.photoDetails.isPrimaryLocation
          ) {
            this.photoService
              .getPrimaryPhotoLocation(this.photoDetails.locationId)
              .toPromise()
              .then((res: any) => {
                this.primaryPhoto = res.Data[0];
              });
          }

          if (this.photoDetails.groupId) {
            this.backToFeed = "/user/group/" + this.photoDetails.groupId;
          }

          if (environment.production) {
            AppShareHelper.convertToHttps(this.photoDetails, "original");
            AppShareHelper.convertToHttps(this.photoDetails, "thumbnail");
          }

          this.isGoldenPhoto = res["Data"]["isGolden"];
          this.deletedUser =
            this.photoDetails.customer.status === UserStatusConstant.DELETED;

          if (res["Data"] && res["Data"]["photoRelated"]) {
            this.photoService
              .getPhotoDetails(
                res["Data"]["photoRelated"],
                false,
                this.localUserId
              )
              .then((res) => {
                if (
                  res["IsSuccess"] &&
                  res["Data"] &&
                  res["Data"]["thumbnail"]
                ) {
                  this.editedPhotoSrc = res["Data"]["thumbnail"];
                }
              });
          }

          if (this.photoDetails.locationId) {
            this.locationService
              .getLocationDetail(this.photoDetails.locationId)
              .toPromise()
              .then((location: any) => {
                if (location.Data) {
                  this.locationDetail = location.Data;
                  // Not show map if lat & lng undefined
                  this.showMap = AppShareHelper.checkLatLngLocation(
                    this.locationDetail
                  );

                  if (
                    this.showMap &&
                    typeof this.locationDetail.address === "string" &&
                    this.locationDetail.address.toLowerCase() === "unknown"
                  ) {
                    // fix bug location sometimes not show on UI
                    this.geoLocationService
                      .getReverseGeo(
                        this.locationDetail.lat,
                        this.locationDetail.lng
                      )
                      .subscribe((data: any) => {
                        this.locationDetail.address =
                          data.display_name || "Unknown";
                      });
                  }
                }
              });
          }

          // Update meta property when got photoDetail
          this.updateMetaProperty(
            res["Data"].title,
            res["Data"].vision,
            res["Data"].thumbnail,
            res["Data"].height,
            res["Data"].width,
            window.location.href
          );

          if (!this.photoDetails.exif) {
            this.photoDetails.exif = {
              model: "Canon EOS 1D X Mark II",
              lens: "50mm F1.8",
              focalLength: "24",
              aperture: "2.2",
              ISO: "300",
              shutterSpeed: "1/1600",
              lat: 0,
              lng: 0,
            };
          }

          localStorage.setItem(
            "lastPhotoView",
            JSON.stringify(this.photoDetails)
          );
          this.photoId = this.photoDetails.id;
          this.tags = this.photoService.getTags(res["Data"]["tags"]);
          this.userService
            .getUserInformation(this.localUserId)
            .then((resolve: any[]) => {
              const userProfile: CamerallaUser = resolve[0];
              this.isAdmin =
                resolve[0].role == PermissionAdminService.adminConst;
              this.isModerator = userProfile.is_moderator === 1;
              this.canDoGlobalAction =
                userProfile.is_moderator === 1 &&
                !this.deletedUser &&
                !this.photoDetails.groupId;
            });

          this.photoDetails.owner_rating_view = {};
          if (this.photoDetails.owner_rating) {
            AppShareHelper.convertViewRatingPoint(
              this.photoDetails.owner_rating,
              this.photoDetails.owner_rating_view
            );
          }

          this.getPhotoOfUser(this.photoDetails["customerId"], photoId);
          this.reloadComment = false;
          this.getComments(this.photoId).then(
            (resolve) => {
              this.photoComments = resolve;
              this.reloadComment = true;
              this.route.queryParams.subscribe((params) => {
                if (params && params.commentId) {
                  setTimeout(() => {
                    let $container = $("html,body");
                    let $scrollTo = $(
                      `.comment-for-scroll-${params.commentId}`
                    );
                    $container.animate(
                      {
                        scrollTop:
                          $scrollTo.offset().top -
                          $container.offset().top +
                          $container.scrollTop() -
                          200,
                        scrollLeft: 0,
                      },
                      300
                    );
                  }, 1000);
                }
              });
            },
            (reject) => console.log(reject)
          );

          this.getSimilarPhotos(this.photoId).then(
            (resolve) => (this.similarPhotos = resolve),
            (reject) => console.log(reject)
          );

          this.ownerPhoto = {
            id: this.photoDetails["customer"]["id"],
            email: this.photoDetails["customer"]["email"],
            status: this.photoDetails["customer"]["status"],
          };
        } else {
          this.router.navigate(["/"]);
          this.toastr.error("Photo ID not found!", "Error");
        }
      },
      (error) => console.log("getPhotoDetails API ERROR" + error)
    );
  }

  totalStars(ratings) {
    let total = 0;

    for (const each of this.criterion) {
      total += ratings[`${each}_count`];
    }

    return total;
  }

  getPhotoOfUser(localUserId, photoId) {
    this.photoService
      .getPhotosByUserId(localUserId, photoId)
      .toPromise()
      .then(
        (response) => {
          this.photosByUser = response["Data"];
        },
        (err) => console.log("getPhotosByUserId API photo Error " + err)
      );
  }

  getSimilarPhotos(photoId) {
    return this.photoService
      .getSuggestPhotos(photoId, this.localUserId)
      .toPromise()
      .then(
        (response) => {
          if (response["IsSuccess"]) {
            return Promise.resolve(response["Data"]);
          }

          return Promise.resolve([]);
        },
        (err) => console.log("similar API photo Error " + err)
      );
  }

  refreshComment() {
    this.getComments(this.photoId).then(
      (resolve) => {
        this.photoComments = resolve;
        this.reloadComment = true;
      },
      (reject) => console.log(reject)
    );
  }

  getComments(photoId) {
    return this.ratingService
      .getRatingByPhoto(this.photoId)
      .toPromise()
      .then(
        (response) => {
          if (response["IsSuccess"]) {
            return Promise.resolve(response["Data"]);
          }

          return Promise.resolve([]);
        },
        (err) => console.log("Comment API Error " + err)
      );
  }

  delete(photoId) {
    const isConfirm = confirm(
      "Do you really want to delete this photo? This process cannot be undone !"
    );

    if (isConfirm) {
      this.photoService
        .deletePhotoById(photoId)
        .toPromise()
        .then(
          (response) => {
            if (response["IsSuccess"] && response["Data"]["count"]) {
              this.toastr.success("Photo removed!");
              if (this.fromUserPage) {
                this.location.back();
              } else {
                setTimeout(() => {
                  if (this.photoDetails.groupId) {
                    window.location.href =
                      environment["site"] +
                      environment["prefixDomain"] +
                      "user/group/" +
                      this.photoDetails.groupId;
                  } else {
                    window.location.href =
                      environment["site"] + environment["prefixDomain"];
                  }
                }, 200);
              }
            } else {
              this.toastr.error("Something wrong!");
            }
          },
          (error) => {
            console.log("delete error " + error);
          }
        );
    }

    return "";
  }

  goToReview() {
    this.router.navigate([`/photo/review/${this.photoId}`]);
  }

  trackByFn(index, item) {
    return index; // or item.id
  }

  openLightbox(): void {
    this.photoService.openLightbox([
      {
        src: this.photoDetails.original,
        caption:
          this.photoDetails.title + " - " + this.photoDetails.customer.fullName,
        thumb: this.photoDetails.thumbnail,
      },
    ]);
  }

  ngOnDestroy() {
    localStorage.setItem("navigateFromDetailPage", "true");
  }

  updateRating(value) {
    value = AppShareHelper.getRealRatingPoint(value);

    if (this.photoDetails.owner_rating) {
      this.photoDetails.owner_rating.general = value;
      this.photoDetails.owner_rating.cameraSettings = value;
      this.photoDetails.owner_rating.composition = value;
      this.photoDetails.owner_rating.presentation = value;
      this.photoDetails.owner_rating.vision = value;
      this.photoDetails.owner_rating.editing = value;

      this.ratingService
        .updateRating(
          this.photoDetails.owner_rating,
          this.photoDetails.owner_rating.id
        )
        .toPromise()
        .then((response) => {
          if (response["IsSuccess"]) {
            this.getPhotoDetails(this.photoDetails.id, true);
          } else {
            this.toastr.error(
              "Something went wrong. Please try again later",
              "ERROR"
            );
          }
        });
    } else {
      this.photoDetails.owner_rating = Photo.getDefaultOwnerRating({
        customerId: this.authService.getLocalUserInfo()["id"],
        general: value,
        photoId: this.photoDetails.id,
        cameraSettings: value,
        composition: value,
        presentation: value,
        vision: value,
        editing: value,
      });
      this.ratingService
        .ratePhoto(this.photoDetails.owner_rating)
        .toPromise()
        .then(
          (response) => {
            if (response["IsSuccess"]) {
              this.getPhotoDetails(this.photoDetails.id, true);
            } else {
              this.toastr.error(
                "Something went wrong. Please try again later",
                "ERROR"
              );
            }
          },
          (error) => {}
        );
    }
  }

  public likeAction(option) {
    this.promiseLike = this.likeService
      .like({
        customerId: this.localUserId,
        photoId: this.photoDetails.id,
        like: option,
      })
      .subscribe(
        (res: any) => {
          if (res.Data) {
            this.photoDetails.owner_like = option;
            this.photoDetails.likesCount = res.Data.likesCount;
          }
        },
        (err) => {
          this.toastr.error(
            "Something went wrong. Please try again later",
            "ERROR"
          );
        }
      );
  }

  public convertPrettifyNumber(value) {
    return this.likeService.convertPrettifyNumber(value);
  }

  shareDialog(url, photoOwnerName) {
    if (url || photoOwnerName) {
      const trimName = photoOwnerName.toLowerCase().replace(/ /g, "");
      window.open(
        "https://www.facebook.com/dialog/share?app_id=546692462944629&display=popup&href=" +
          url +
          "&hashtag=%23" +
          trimName +
          "&quote=Photo by: " +
          photoOwnerName +
          " - @" +
          trimName
      );
      // window.open('http://www.facebook.com/sharer.php?u=https://camerallaphoto.com/photo/thumbnail/eyxm3s1588797602390_thumb.jpeg?img=https://camerallaphoto.com/photo/thumbnail/eyxm3s1588797602390_thumb.jpeg' + '&hashtag=%23'+ trimName,'','width=1000, height=1000, scrollbars=yes, resizable=no');
    }
  }

  // Use this if you want to share a post with title, description, ...
  updateMetaProperty(title, description, imageUrl, imgHeight, imgWidth, url) {
    if (title) {
      this.meta.updateTag({ property: "og:title", content: title });
    }

    if (description) {
      this.meta.updateTag({ property: "og:description", content: description });
    }

    if (imageUrl) {
      this.meta.updateTag({ property: "og:image", content: imageUrl });
    }

    if (imgHeight && imgWidth) {
      this.meta.addTags([
        { property: "og:image:height", content: imgHeight },
        { property: "og:image:width", content: imgWidth },
      ]);
    }

    if (url) {
      this.meta.updateTag({ property: "og:url", content: url });
    }
  }

  errorPhoto() {
    if (
      /^((?!chrome|android).)*safari/i.test(navigator.userAgent) &&
      !/AppleWebKit(.*)(?=Crios)(.*)/gim.test(navigator.userAgent)
    ) {
      AppComponent.eventOnImageError.next();
    }
    this.photoDetails.thumbnail = this.defaultErrorPhoto;
  }

  markAsPrimaryPhoto() {
    this.groupService
      .markAsPrimaryPhoto({
        groupId: this.photoDetails.groupId,
        photoId: this.photoDetails.id,
        locationId: this.photoDetails.locationId,
      })
      .subscribe((res: any) => {
        this.photoDetails.isPrimaryLocation = res.Data.isPrimaryLocation;
        this.toastr.success("Mark as primary photo successfully", "SUCCESS");
      });
  }

  openMap(compareMode = false) {
    if (this.showMap) {
      const modalRef = this.modalService.open(MapPopupComponent, {
        backdrop: "static",
        windowClass: "map-modal",
      });
      modalRef.componentInstance.lat = this.locationDetail.lat;
      modalRef.componentInstance.lng = this.locationDetail.lng;
      modalRef.componentInstance.description = this.locationDetail.description;
      modalRef.componentInstance.address = this.locationDetail.address;
      modalRef.componentInstance.viewOnly = true;
      if (compareMode) {
        modalRef.componentInstance.locationId = this.photoDetails.locationId;
        modalRef.componentInstance.isGolden =
          this.photoDetails.isGoldenLocation;
        modalRef.componentInstance.compareMode = true;
      }
    }
  }

  openComparisonSlider() {
    if (this.editedPhotoSrc && this.photoLoaded) {
      if (!this.showComparisonSlider) {
        $("html, body").animate(
          {
            scrollTop: $("#border-photo-section").offset().top - 100,
          },
          2000
        );
      }
      this.showComparisonSlider = !this.showComparisonSlider;
    }
  }

  loadImage() {
    setTimeout(() => {
      this.photoLoaded = true;
    });
  }

  loadCompareImage() {
    setTimeout(() => {
      $(".reveal").toggleClass("show");
      if (document.querySelector(".cocoen")) {
        new Cocoen(document.querySelector(".cocoen"));
      }
    });
  }

  public checkSizeWindowMobile() {
    return screen.width <= PhotoDetailsComponent.maxWidthMobile;
  }

  handleGlobalPhoto(data, partner?) {
    const partnerId = this.isGoldenPhoto == partner.id ? 0 : partner.id;
    this.photoService
      .checkGoldenPhoto(partnerId, { photoId: data.id })
      .subscribe((res: any) => {
        if (res.IsSuccess) {
          this.isGoldenPhoto = res.Data.isGolden;
          this.photoDetails.isGolden = res.Data.isGolden;
          this.photoService.modifiedPhoto = this.photoDetails;

          if (res.Data.isGolden) {
            this.addAutoComment("goldenPhoto");
          }
          this.toastr.success(
            (this.isGoldenPhoto != 0 ? "Add" : "Remove") +
              " golden photo success",
            "SUCCESS"
          );
        } else {
          this.toastr.error(res.Message);
        }
      });
  }

  handleGoldenLocation(isGoldenLocation, notRemovePoint = true) {
    this.locationService
      .updateLocation(this.locationDetail.id, {
        status: !isGoldenLocation,
        photoId: this.photoDetails.id,
        notRemovePoint: notRemovePoint,
      })
      .subscribe((res: any) => {
        if (res.IsSuccess) {
          this.photoDetails.isGoldenLocation = !isGoldenLocation;
          this.locationDetail = res.Data;
          this.photoService.modifiedPhoto = this.photoDetails;
          if (!isGoldenLocation) {
            this.addAutoComment("goldenLocation");
            this.photoDetails.isPrimaryLocation = true;
          }
          this.toastr.success(
            (res.Data.status != 0 ? "Add" : "Remove") +
              " golden location successfully",
            "SUCCESS"
          );
        } else {
          this.toastr.error(res.Message);
        }
      });
  }

  openMoveToLocation() {
    const modalRef = this.modalService.open(MoveLocationForm, {
      backdrop: "static",
    });
    modalRef.componentInstance.fromLocationId = this.locationDetail.id;
    modalRef.componentInstance.photoId = this.photoDetails.id;
    modalRef.componentInstance.moveSuccess.subscribe((res) => {
      this.getPhotoDetails(res.id);
    });
  }

  addAutoComment(type) {
    let isEditorChoice = false;
    let text = null;
    let giveReward = null;
    let actionId = null;
    let rewardName = null;
    switch (type) {
      case "editorChoice":
        isEditorChoice = true;
        if (environment.ticketFeature) {
          text = `Congratulations, this photo is an “Editors Choice”. You have received more tickets for the competition "Win a trip to Africa". Read more about the competition on "My page". The photo will also be shared to our social media.`;
        } else {
          text = `Congratulations, our team has selected your photo as an Editor's Choice! Your photo will be shared with the Cameralla community and across our social media platforms. It is now also showcased in the Editor's Choice photo feed. Well done!`;
        }
        break;
      case "goldenPhoto":
        text = `Congratulations! Your photo has received the prestigious 'Golden Photo' recognition. This is the highest photo award in Cameralla, granted by our lead photographer, course creator, and founder: Jørn Allan Pedersen. This recognition will also be shared to the Cameralla community and is now featured in the exclusive Golden Photo feed. Well captured!`;
        if (environment.ticketFeature) {
          text =
            'Congratulations! Your photo has been awarded a Golden Photo. You have received more tickets for the competition "Win a trip to Africa". Read more about the competition on "My page"';
        }
        break;
      case "goldenLocation":
        if (environment.ticketFeature) {
          text = `Congratulations! Your photo has been awarded a Golden location. You have received more tickets for the competition "Win a trip to Africa". Read more about the competition on "My page". This location is added to the map`;
        } else {
          text = `Congratulations! Your photo has achieved 'Golden Location' status. This unique location has been added to the map and is now visible to the entire Cameralla community. Others can now explore, check-in, and share their own captures at this remarkable location. Great shot!`;
        }
        break;

      // actionId is reward type, actionId can find in action table in DB or action migrate file
      // discussing
      case "mostDiscussed24Hours":
        text = `Wow! This photo is featured as "Top 10 most talked about - Last 24 hours”! Keep up the good work!`;
        actionId = 16;
        rewardName = "Top 10 Most talked about last 24 hours";
        break;
      case "mostDiscussed7Days":
        text = `Wow! This photo is featured as "Top 10 most talked about - Last 7 days”! Keep up the good work!`;
        actionId = 17;
        rewardName = "Top 10 Most talked about last 7 days";
        break;
      case "mostDiscussed30Days":
        text = `Wow! This photo is featured as "Top 10 most talked about - Last 30 days”! Keep up the good work!`;
        actionId = 18;
        rewardName = "Top 10 Most talked about last 30 days";
        break;

      //Viewing
      case "mostViewed24Hours":
        text = `Well done! This photo is featured as "Top 10 most viewed - Last 24 hours”! Congratulations on a great photo!`;
        actionId = 19;
        rewardName = "Top 10 Most viewed last 24 hours";
        break;
      case "mostViewed7Days":
        text = `Well done! This photo is featured as "Top 10 most viewed - Last 7 days”! Congratulations on a great photo!`;
        actionId = 20;
        rewardName = "Top 10 Most viewed last 7 days";
        break;
      case "mostViewed30Days":
        text = `Well done! This photo is featured as "Top 10 most viewed - Last 30 days”! Congratulations on a great photo!`;
        actionId = 21;
        rewardName = "Top 10 Most viewed last 30 days";
        break;

      // rating
      case "highestRated24Hours":
        text = `You’re trending! This photo is featured as "Top 10 highest rated - Last 24 hour"! Keep sharing your wonderful photos!`;
        actionId = 22;
        rewardName = "Top 10 Highest rated last 24 hours";
        break;
      case "highestRated7Days":
        text = `You’re trending! This photo is featured as "Top 10 highest rated - Last 7 days”! Keep sharing your wonderful photos!`;
        actionId = 23;
        rewardName = "Top 10 Highest rated last 7 days";
        break;
      case "highestRated30Days":
        text = `You’re trending! This photo is featured as "Top 10 highest rated - Last 30 days”! Keep sharing your wonderful photos!`;
        actionId = 24;
        rewardName = "Top 10 Highest rated last 30 days";
        break;
    }

    if (actionId) {
      if (this.checkRewardStatus(actionId, this.photoDetails.photoRewards)) {
        this.toastr.error("This photo has already had this reward!", "Error");
        return;
      }
    }

    this.photoDetails.isEditorChoice = isEditorChoice;
    const ratingModel = Photo.getDefaultOwnerRating({
      autoComment: true,
      general_text: text,
      customerId: environment.editorVoiceId,
      photoId: this.photoDetails.id,
      create_at: new Date().toISOString(),
      update_at: new Date().toISOString(),
      isEditorChoice: isEditorChoice,
      giveReward: actionId,
      rewardName: rewardName,
    });

    this.ratingService.ratePhoto(ratingModel).subscribe((rating: any) => {
      this.photoDetails.isEditorChoice = isEditorChoice;
      this.refreshComment();

      const ratingData = {
        content: rating.Data.owner_rating.general_text,
        photoId: this.photoDetails.id,
        modelId: rating.Data.owner_rating.id,
      };

      if (actionId) {
        this.photoDetails.photoRewards.push({
          actionId: actionId,
        });
      }

      this.userCommentsService.sendMessage(
        [],
        this.photoDetails["customer"],
        environment.editorVoiceId,
        ratingData
      );
    });
  }

  translate(photoDetail) {
    if (photoDetail.originalTitle) {
      photoDetail["vision"] = photoDetail.originalVision;
      photoDetail["title"] = photoDetail.originalTitle;
      delete photoDetail.originalTitle;
      delete photoDetail.originalVision;
    } else {
      this.translateService
        .translate(
          [photoDetail["title"], photoDetail["vision"]],
          navigator.language
        )
        .toPromise()
        .then((res: any) => {
          photoDetail.originalTitle = photoDetail.title;
          photoDetail.originalVision = photoDetail.vision;
          photoDetail.title =
            res.data && res.data.translations
              ? res.data.translations[0].translatedText
              : photoDetail.title;
          photoDetail.vision =
            res.data && res.data.translations
              ? res.data.translations[1].translatedText
              : photoDetail.vision;
        });
    }
  }

  getPartner() {
    this.http.get(AppService.getApiUrl() + "/api/partners/").subscribe(
      (res: any) => {
        if (res.Data) {
          this.partners = res.Data;
        }
      },
      (error) => {
        this.toastr.error(error.error.Message, "Error");
      }
    );
  }

  checkRewardStatus(actionId, photoRewards) {
    return _.find(photoRewards, function (item) {
      return item.actionId == actionId;
    });
  }

  public translationButtonText(comment) {
    return AppShareHelper.translationButtonText(comment, "originalTitle");
  }

  public checkPhotoIsInBio() {
    const photoIds = this.myBioInfo.photoIds || [];
    return photoIds.includes(this.photoDetails.id);
  }

  public adjustPhotoInBio(remove) {
    let tempPhotoIds = [];
    if (!remove) {
      tempPhotoIds = [...this.myBioInfo.photoIds];
      tempPhotoIds.push(this.photoDetails.id);
      console.log(this.photoDetails.id);
    } else {
      tempPhotoIds = this.myBioInfo.photoIds.filter((item) => {
        return item !== this.photoDetails.id;
      });
    }

    const bioDataRequest = {
      ...this.myBioInfo,
    };

    bioDataRequest.photoIds = tempPhotoIds;

    this.bioService
      .saveBio(bioDataRequest)
      .toPromise()
      .then((res: any) => {
        this.myBioInfo = res.Data;
        this.toastr.success("Update photo to Bio successfully");
      });
  }
}
